import React, { useState, useEffect, useRef } from "react";

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { hideModal } from "../../stores/modalSlice";

// Components
import OrderCartComponent from "./OrderCartComponent";
import CreateOrderComponent from "./CreateOrderComponent";
import ToCartButtonComponent from "../../components/ToCartButtonComponent";
import SpinnerComponent from "../../components/SpinnerComponent";
import ModalComponent from "../../components/ModalComponent";

function OrderPage() {
	const dispatch = useDispatch();
	const [isOffCanvas, setIsOffCanvas] = useState(false);
	const [showOffCanvas, setShowOffCanvas] = useState(false);
	const [loading, setLoading] = useState(false);

	const [cartQuantity, setCartQuantity] = useState(0);
	
	const cart = useSelector((state) => state.cart);

	const userMessageModal = useSelector((state) => state.userMessageModal);

	const previousWidth = useRef(window.innerWidth);

	const handleResize = () => {
		const currentWidth = window.innerWidth;
		if (currentWidth !== previousWidth.current) {
			setShowOffCanvas(false);
			if (currentWidth < 1200) {
				setIsOffCanvas(true);
			} else {
				setIsOffCanvas(false);
			}
			previousWidth.current = currentWidth;
		}
	};

	const toggleOffCanvas = () => {
		setShowOffCanvas(!showOffCanvas);
	};

	const changeLoading = (status) => { setLoading(status); };

	useEffect(() => {
		window.addEventListener('resize', handleResize);
		handleResize();

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		setShowOffCanvas(false);
		if (window.innerWidth < 1200) {
			setIsOffCanvas(true);
		} else {
			setIsOffCanvas(false);
		}
	}, []);
	

	useEffect(() => {

		var quantity = 0;

		if (cart.products?.length > 0) {
			cart.products.forEach((item) => {
				quantity = Number(quantity) + Number(item.quantity);
			});
		}
		setCartQuantity(quantity);

	}, [cart]);

	return (
		<div className="container mt-5">
			{isOffCanvas ? (
				<div className="d-flex justify-content-end mb-2 cart-icon-button">
					<ToCartButtonComponent itemCount={cartQuantity} handleClick={toggleOffCanvas} />
				</div>
			) : ("")}
			<div className="container mb-4">

				{loading ? (<SpinnerComponent />) : (

					<div className="row">
						<div className={isOffCanvas ? "col-12" : "col-md-6"}>
							<CreateOrderComponent loading={changeLoading} />
						</div>

						<div className="col-md-6" >
							<OrderCartComponent isOffCanvas={isOffCanvas} showOffCanvas={showOffCanvas} toggleOffCanvas={toggleOffCanvas} />
						</div>

					</div>
				)}
			</div>


			<ModalComponent
				show={userMessageModal.show}
				title={userMessageModal.title}
				message={userMessageModal.message}
				showWhats={userMessageModal.showWhats}
				handleClose={() => dispatch(hideModal())}
			/>
		</div>

	);
}

export default OrderPage;
